import React, { useCallback, useEffect, useState } from "react";
import PillElement from "../../components/mentalMap/pillElement";
import ArrowElement from "../../components/mentalMap/arrowElement";
import HomePageCards from "../../components/homePageCards";
import MiniPill from "../../components/mentalMap/minipill";
import { Grid, useMediaQuery } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import { icons } from "../../constants";
import images from "../../constants/images";
import HeaderBanner from "../../components/headerBanner";
import {
  headerBannerType,
  processMapBannerContent
} from "../../constants/enums";
import { useDispatch, useSelector } from "react-redux";
import {
  setSelectedMapItem,
  resetSelectedMapItem,
  changeManagementHeaderBtnState,
  changeDirectorGestionBtnState,
  changeMarketingPromotionManagementBtnState,
} from "../../redux/slices/navigationSlice";
import "./styles.css";
import MainLayout from "../../layouts/mainLayout";
import { setBannerData } from "../../redux/slices/utilsDataSlice";
import {
  callApiAsync,
  getCallJsonSettingVersion,
  postUpdateRisksAndOpportunities,
  syncImportRegistrationStates
} from "../../services/apiService";
import ToastNotification from "../../components/toastNotification";
import { hasAnyRoleUtil, isRoleUtil } from "../../utils/AuthorizedUtils/360Report";
import {
  TASK_ROLES
} from "../../constants/taskManagerRoles";
import { useActiveSession } from "../../utils/sessionGuard";

const Home = () => {
  const [percentageDetails, setPercentageDetails] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isCheckingSession, userId } = useActiveSession({
    loadAuthorities: true
  });
  const [toastMessage, setToastMessage] = useState("tes");
  const [showToast, setShowToast] = useState(false);
  const [loginWarningMessage, setLoginWarningMessage] = useState("");

  const isLargeScreen = useMediaQuery("(min-width:1000px)");

  const MANAGEMENT_ROLES = [
    "SERALOGIN_MANAGEMENT",
    "MANAGEMENT",
    "DIRECTOR",
    "GENERAL_MANAGEMENT",
    "RISK_AND_OPP_MODULE_ADMIN",
    "RISK_AND_OPP_DOFA_ADMIN",
    "RISK_AND_OPP_STRATEGY_ADMIN",
    "SERALOGIN_RISK_AND_OPP_ACCESS",
    "SERALOGIN_PROCESS_LEADER_ADMINISTRATIVE_MANAGEMENT",
    "SERALOGIN_PROCESS_LEADER_BIOMEDICAL_MANAGEMENT",
    "SERALOGIN_PROCESS_LEADER_COMMERCIAL_MANAGEMENT",
    "SERALOGIN_PROCESS_LEADER_HUMAN_RESOURCES_MANAGEMENT",
    "SERALOGIN_PROCESS_LEADER_HSQ_MANAGEMENT",
    "SERALOGIN_PROCESS_LEADER_MARKETING_AND_PROMOTION_MANAGEMENT",
    "SERALOGIN_PROCESS_LEADER_CUSTOMER_SERVICE_MANAGEMENT",
    "SERALOGIN_PROCESS_LEADER_FINANCIAL_AND_ACCOUNTING_MANAGEMENT",
    "SERALOGIN_PROCESS_LEADER_PHARMACEUTICAL_MANAGEMENT",
    "SERALOGIN_PROCESS_LEADER_MANAGEMENT_DIRECTION",
    "SERALOGIN_PROCESS_LEADER_FOREIGN_TRADE_DIRECTION",
    "SERALOGIN_PROCESS_LEADER_TECHNICAL_SUPPORT_DIRECTION",
    "SERALOGIN_PROCESS_LEADER_SAFETY_AND_HEALTH_AT_WORK",
    "SERALOGIN_PROCESS_LEADER_FOREIGN_TRADE_MANAGEMENT",
    "SERALOGIN_PROCESS_LEADER_CUSTOMER_SERVICE_PHARMADIA",
    "ADMINISTRATIVE_MANAGEMENT_LEADER",
    "BIOMEDICAL_MANAGEMENT_LEADER",
    "COMMERCIAL_MANAGEMENT_LEADER",
    "HUMAN_RESOURCES_MANAGEMENT_LEADER",
    "MARKETING_AND_PROMOTION_MANAGEMENT_LEADER",
    "CUSTOMER_SERVICE_MANAGEMENT_LEADER",
    "FINANCIAL_AND_ACCOUNTING_MANAGEMENT_LEADER",
    "PHARMACEUTICAL_MANAGEMENT_LEADER",
    "MANAGEMENT_DIRECTOR_LEADER",
    "HSQ_MANAGEMENT_LEADER",
    "TECHNICAL_DIRECTION_TECHNICAL_SUPPORT_LEADER",
    "SAFETY_AND_HEALTH_AT_WORK_LEADER",
    "EXTERNAL_CLIENT",
    "FOREIGN_TRADE_MANAGEMENT_LEADER"
  ];

  const INTERESTED_PARTIES_ROLES = [
    "INTERESTED_PARTIES_MODULE_ADMIN",
    "SERALOGIN_INTERESTED_PART_ACCESS",
    "SERALOGIN_INTERESTED_PART_PILAR_ACCESS",
    "INTERESTED_PARTIES_COLLABORATOR",
  ];

  const WALLET_ROLES = [
    "WALLET_MODULE_ADMIN",
    "SERALOGIN_WALLET_ACCESS",
    "WALLET_ADMIN",
    "WALLET_PAYMENT_ADMIN",
    "WALLET",
  ];

  const SUPPLIERS_ROLES = [
    "SUPPLIERS_MODULE_ADMIN",
    "SERALOGIN_SUPPLIERS_ACCESS",
    "SUPPLIERS_NATIONAL_ADMIN",
    "SUPPLIERS_INTERNATIONAL_ADMIN",
    "SUPPLIERS_SERVICE_ADMIN",
  ];

  const CLIENTS_ROLES = [
    "CLIENTS_MODULE_ADMIN",
    "SERALOGIN_CLIENTS_ACCESS",
    "CLIENTS_MASSIVE_UPLOAD_ADMIN",
  ];

  const HUMAN_MANAGEMENT_ROLES = ["SERALOGIN_HUMAN_MANAGEMENT_ACCESS"];

  const MARKETING_PROMOTION_ROLES = [
    "MARKETING_PROMOTION_MODULE_ADMIN",
    "SERALOGIN_MARKETING_PROMOTION_ACCESS",
    "MARKETING_PROMOTION_ANALYSIS_ADMIN",
  ];

  const openPercentageDetails = () => {
    setPercentageDetails(!percentageDetails);
  };

  const userData = useSelector((state) => state.userData.userData);

  var isExternalClient = isRoleUtil("EXTERNAL_CLIENT", userData.roleList);
  var isAdminBanner = isRoleUtil("ADMIN_BANNER", userData.roleList);

  var isWalletAdmin = isRoleUtil("WALLET_ADMIN", userData.roleList);
  var isWallet = isRoleUtil("WALLET", userData.roleList);

  const redirectionPath = getRedirectionPath(userData.roleList);

  function hasRole(rolesToCheck, userRoleList = []) {
    if (Array.isArray(rolesToCheck)) {
      return hasAnyRoleUtil(rolesToCheck, userRoleList);
    }
    return isRoleUtil(rolesToCheck, userRoleList);
  }

  function getRedirectionPath(userRoleList = []) {
    if (isRoleUtil("ADMIN_BANNER", userRoleList))
      return "/management_direction/banner_admin";
    if (hasRole(MANAGEMENT_ROLES, userRoleList))
      return "/riskAndOpportunityManagement";
    if (hasRole(WALLET_ROLES, userRoleList)) return "/wallet";
    if (isRoleUtil("SERALOGIN_ONLINE_ACCESS", userRoleList))
      return "/seralogin_online";
    if (hasRole(CLIENTS_ROLES, userRoleList)) return "/clients";
    if (hasRole(SUPPLIERS_ROLES, userRoleList)) return "/suppliers";
    if (isRoleUtil("SERALOGIN_REQUIREMENTS_ACCESS", userRoleList))
      return "/requirements";
    if (hasRole(HUMAN_MANAGEMENT_ROLES, userRoleList))
      return "/superior_rol_dashboard";
    if (hasRole(MARKETING_PROMOTION_ROLES, userRoleList))
      return "/marketingPromotionManagement";
    if (hasRole(TASK_ROLES, userRoleList)) return "/manage_time";
    if (hasRole(INTERESTED_PARTIES_ROLES, userRoleList))
      return "/gestion_HSQ_GCD/interestedParties";
    return "/gestion_HSQ_GCD/interestedParties";
  }

  // if (isRoleUtil("ADMIN_BANNER", userData.roleList)) {
  //   redirectionPath = "/management_direction/banner_admin";
  // } else if (isRoleUtil("LIDER_CALIDAD", userData.roleList)) {
  //   redirectionPath = "/gestion_HSQ_GCD/interestedParties";
  // } else {
  //   redirectionPath = "/riskAndOpportunityManagement";
  // }

  const getVersion = useCallback(async () => {
    callApiAsync(getCallJsonSettingVersion, (data) => {
      dispatch(setBannerData(data));
    });
  }, [dispatch]);

  const updateRiskAndOpportunitiesByMonth = useCallback(async () => {
    if (!userId) return;
    callApiAsync(() => postUpdateRisksAndOpportunities({ userId: userId }));
  }, [userId]);

  const syncImportRegistrationStatesTable = useCallback(async () => {
    if (!userId) return;
    callApiAsync(() => syncImportRegistrationStates({ userId: userId }));
  }, [userId]);

  useEffect(() => {
    getVersion();
  }, [getVersion]);

  useEffect(() => {
    if (isCheckingSession || !userId) return;

    updateRiskAndOpportunitiesByMonth();
    syncImportRegistrationStatesTable();
    dispatch(changeManagementHeaderBtnState(false));
    dispatch(changeDirectorGestionBtnState(false));
    dispatch(changeMarketingPromotionManagementBtnState(false));
  }, [
    dispatch,
    isCheckingSession,
    syncImportRegistrationStatesTable,
    updateRiskAndOpportunitiesByMonth,
    userId
  ]);

  useEffect(() => {
    const loginSuccessMessage = sessionStorage.getItem("plusLoginSuccessMessage");
    const warningMessage = sessionStorage.getItem("plusLoginWarningMessage");
    if (warningMessage) {
      setLoginWarningMessage(warningMessage);
    }
    if (loginSuccessMessage) {
      setToastMessage(loginSuccessMessage);
      setShowToast(true);
      sessionStorage.removeItem("plusLoginSuccessMessage");
    }
  }, []);

  useEffect(() => {
    dispatch(resetSelectedMapItem());
  }, [dispatch]);

  if (isCheckingSession || !userId) return null;

  return (
    <>
      <div className="home-process-map-banner">
        <HeaderBanner
          type={headerBannerType.processMap}
          fixedTitle={processMapBannerContent.title}
          fixedSubTitle={processMapBannerContent.subTitle}
        />
      </div>
      <h2 className="map-sub-title">"En búsqueda de la excelencia"</h2>
      {loginWarningMessage && (
        <div
          style={{
            maxWidth: "780px",
            margin: "16px auto 8px",
            padding: "16px 20px",
            borderRadius: "12px",
            border: "1px solid #f2c94c",
            background: "#fff8df",
            color: "#6b4f00",
            boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
            textAlign: "center",
            fontWeight: 600
          }}
        >
          {loginWarningMessage}
        </div>
      )}
      <br />
      <div
        className="mentalMap container-scroll"
        style={{ pointerEvents: isExternalClient ? "none" : "auto" }}
      >
        <div className="VContainer" style={{ margin: "0 -170px 0 0" , zIndex: 1000}}>
          <div className="Hcontainer mental-map-first-column">
            <Link to="/dashboard" className="no-underline">
              <PillElement
                color={"#f0cd01"}
                text={"Contexto de la Organización"}
                iconPosition={true}
                id="lp-1"
                icon={icons.mindMap}
                iconSize={"22px"}
                onClick={() =>
                  dispatch(setSelectedMapItem("organizational-context"))
                }
              />
            </Link>
            <div className="arrow-container-l">
              <img
                className="conect-arrow-l"
                src={images.arrowLeftRDown}
                alt="arrow"
              />
            </div>
            <Link to="/interestedPartiesGraph" className="no-underline">
              <PillElement
                color={"#f0cd01"}
                text={"Partes Interesadas"}
                id="lp-2"
                iconSize={"23px"}
                icon={icons.group}
              />
            </Link>
            <div className="arrow-container-r">
              <img
                className="conect-arrow-r"
                src={images.arrowRightLDown}
                alt="arrow"
              />
            </div>
            <Link to="/suppliers" className="no-underline">
              <PillElement
                color={"#f0cd01"}
                text={"Proveedores"}
                id="lp-3"
                iconPosition={true}
                icon={icons.prooveedores}
              />
            </Link>

            <div className="arrow-container-l">
              <img
                className="conect-arrow-l"
                src={images.arrowLeftRDown}
                alt="arrow"
              />
            </div>
            <Link to="/clients" className="no-underline">
              <PillElement
                color={"#6a6ad8"}
                text={"Clientes"}
                id="lp-4"
                icon={icons.tieMan}
              />
            </Link>
            <div className="arrow-container-c">
              <img
                className="conect-arrow-d-II"
                src={images.arrowDownLong}
                alt="arrow"
              />
            </div>
            <div style={{ marginTop: "50px" }}>
              <Link to="/requirements" className="no-underline">
                <PillElement
                  color={"#f0cd01"}
                  text={"Requerimientos"}
                  id="lp-5"
                  icon={icons.checkList}
                />
              </Link>
            </div>
            <div className="arrow-container-r-conect">
              <img
                className="arrow-side-left"
                src={images.arrowSideLeft}
                alt="arrow"
              />
            </div>
          </div>
        </div>

        <div className="VContainer">
          <div
            className="HContainer j-center"
            style={{ display: "flex", flexDirection: "row" }}
          >
            <div
              className="containerBlue topMiddleLeft"
              id="strategyc-container"
            >
              <p className="map-title-container">PROCESOS ESTRATÉGICOS</p>

              <ArrowElement
                width={"140px"}
                height={"45px"}
                type={"blue-arrow-II"}
                text={"Gestión de la Dirección GDI"}
              />
            </div>
            <img
              src="/images/flechita.svg"
              alt="Flecha"
              className="arrow-connector-section"
            />
            <div
              className="containerBlue topMiddleRigth"
              id="control-container"
            >
              <p
                className="map-title-container"
                style={{ width: "165px", whiteSpace: "collapse" }}
              >
                PROCESOS DE MEJORAMIENTO Y CONTROL
              </p>
              <Link to={redirectionPath} className="no-underline">
                <ArrowElement
                  onClick={() => {
                    dispatch(changeManagementHeaderBtnState(false));
                    dispatch(changeDirectorGestionBtnState(true));
                  }}
                  width={"140px"}
                  height={"45px"}
                  type={"blue-arrow-II"}
                  text={"Gestión HSQ GCD"}
                />
              </Link>
            </div>
          </div>

          <div className="down-arrow-line">
            <img
              className="mind-map-down-arrow"
              src={images.flecha_abajo}
              alt="arrow"
            />
            <img
              className="mind-map-down-arrow"
              src={images.flecha_abajo}
              alt="arrow"
            />

            <img
              className="mind-map-down-arrow"
              src={images.flecha_abajo}
              alt="arrow"
            />
          </div>
          <div
            className="containerBlue2 middleContainer"
            id="procces-container"
          // style={{ marginTop: "20px" }}
          >
            <p className="map-title-container">procesos operacionales</p>

            <div>
            <Link to="/foreign_trade_board" className="no-underline">
              <ArrowElement
                width={"580px"}
                type={"long-green-arrow"}
                textWidth={"140px"}
                text={"Gestión Comercio Exterior GCE"}
              />
              </Link>
              <div className="mind-map-downUp-arrow-group">
                <img
                  className="mind-map-downUp-arrow downUp1"
                  src={images.arrowDownUp}
                  alt="arrow"
                />
                <img
                  className="mind-map-downUp-arrow downUp2"
                  src={images.arrowDownUp}
                  alt="arrow"
                />
                <img
                  className="mind-map-downUp-arrow downUp3"
                  src={images.arrowDownUp}
                  alt="arrow"
                />
                <img
                  className="mind-map-downUp-arrow downUp4"
                  src={images.arrowDownUp}
                  alt="arrow"
                />
              </div>
              <ArrowElement
                width={"580px"}
                type={"long-green-arrow"}
                textWidth={"140px"}
                text={"Gestión de Servicio al Cliente GSC"}
              />
            </div>

            <div className="mind-map-downUp-arrow-group">
              <img
                className="mind-map-downUp-arrow downUp1"
                src={images.arrowDownUp}
                alt="arrow"
              />
              <img
                className="mind-map-downUp-arrow downUp2"
                src={images.arrowDownUp}
                alt="arrow"
              />
              <img
                className="mind-map-downUp-arrow downUp3"
                src={images.arrowDownUp}
                alt="arrow"
              />
              <img
                className="mind-map-downUp-arrow downUp4"
                src={images.arrowDownUp}
                alt="arrow"
              />
            </div>
            <div
              className="HContainer j-center"
              style={{
                display: "flex",
                flexDirection: "row",
                marginTop: "10px"
              }}
            >
              <div>
                <ArrowElement
                  type={"green-arrow"}
                  text={"Gestión Comercial GCO"}
                  width={"105px"}
                  height={"100px"}
                  textWidth={"60px"}
                />
              </div>
              <img
                src="/images/flechita.svg"
                alt="Flecha"
                className="arrow-connector"
              />
              <div>
                <Link
                  to="/marketingPromotionManagement"
                  className="no-underline"
                  state={{ menuItemId: 1 }}
                >
                  <ArrowElement
                    onClick={() => {
                      dispatch(changeManagementHeaderBtnState(false));
                      dispatch(
                        changeMarketingPromotionManagementBtnState(true)
                      );
                    }}
                    type={"green-arrow"}
                    text={"Gestión Mercadeo y Promoción GMP"}
                    width={"105px"}
                    height={"100px"}
                    textWidth={"80px"}
                  />
                </Link>
              </div>
              <img
                src="/images/flechita.svg"
                alt="Flecha"
                className="arrow-connector"
              />
              <div>
                <ArrowElement
                  type={"green-arrow-container"}
                  text={"Gestión Farmaceutica GSF"}
                  width={"270px"}
                  height={"100px"}
                  textWidth={"125px"}
                  marginItem={"0 0 0 -20px"}
                  btns={[
                    {
                      text: "Selección",
                      url: "https://www.google.com/",
                      width: "60px"
                    },
                    {
                      text: "Adquisición",
                      url: "https://www.google.com/",
                      width: "60px"
                    },
                    {
                      text: "Recepción",
                      url: "https://www.google.com/",
                      width: "60px"
                    },
                    {
                      text: "Almacenamiento",
                      url: "https://www.google.com/",
                      width: "79px"
                    },
                    {
                      text: "Distribucion",
                      url: "https://www.google.com/",
                      width: "60px"
                    }
                  ]}
                />
              </div>
              <img
                src="/images/flechita.svg"
                alt="Flecha"
                className="arrow-connector"
              />
              <div item xs={2} sm={2} md={2}>
                <Link
                  to="/biomedicalManagementDashboard"
                  className="no-underline"
                >
                  <ArrowElement
                    type={"green-arrow"}
                    text={"Gestión Biomédica GB"}
                    width={"105px"}
                    height={"100px"}
                    textWidth={"60px"}
                  />
                </Link>
              </div>
            </div>
          </div>

          <div className="mind-map-downUp-arrow-groupII">
            <img
              className="mind-map-downUp-arrow"
              src={images.arrowDownUp}
              alt="arrow"
            />
            <img
              className="mind-map-downUp-arrow"
              src={images.arrowDownUp}
              alt="arrow"
            />
          </div>

          <div id="process-container" style={{ marginTop: "15px" }}>
            <div className="containerBlue3 third-center-container">
              <p className="map-title-container">PROCESOS DE SOPORTE</p>
              <Grid
                container
                spacing={0}
                alignItems="center"
                style={{ marginLeft: "10px" }}
              >
                <Grid
                  item
                  xs={4}
                  sm={4}
                  md={4}
                  container
                  direction="row"
                  justifyContent="center"
                  alignItems="center"
                >
                  <ArrowElement
                    onClick={() => {
                      dispatch(changeManagementHeaderBtnState(true));
                    }}
                    type={"blue-arrow"}
                    width={"170px"}
                    height={"50px"}
                    text={"Gestión Humana GHU"}
                  />
                </Grid>
                <img
                  src="/images/flechita.svg"
                  alt="Flecha"
                  className="arrow-connector"
                />
                <Grid
                  item
                  xs={4}
                  sm={4}
                  md={4}
                  container
                  direction="row"
                  justifyContent="center"
                  alignItems="center"
                >
                  <ArrowElement
                    type={"blue-arrow"}
                    width={"170px"}
                    height={"50px"}
                    text={"Gestión Administrativa GDA"}
                  />
                </Grid>
                <img
                  src="/images/flechita.svg"
                  alt="Flecha"
                  className="arrow-connector"
                />
                <Grid
                  item
                  xs={4}
                  sm={4}
                  md={4}
                  container
                  direction="row"
                  justifyContent="center"
                  alignItems="center"
                >
                  <ArrowElement
                    type={"blue-arrow"}
                    width={"170px"}
                    height={"50px"}
                    text={"Gestión Financiera y Contable GFC*"}
                    onClick={() => {
                      navigate("/wallet");
                    }}
                  />
                </Grid>
              </Grid>
            </div>

            <div
              className={`${isLargeScreen ? "HContainer j-center" : ""}`}
              style={{ display: "flex", flexDirection: "row" }}
            >
              <div className="containerBlue3 fourth-center-container" style={{ backgroundColor: 'white' }}>

                {/* <Link to="/riskAndOpportunityManagement" className="no-underline">
                  <PillElement
                    color={"#96D2F0"}
                    text={"Gestión de Riesgos y Oportunidades"}
                    id="lp-5"
                    icon={icons.graphBar}
                    iconSize={"17px"}
                    width="180px"
                    textColor={"#666666"}
                  />
                </Link> */}
              </div>
            </div>
          </div>


        </div>

        <div className="mental-map-third-column">
          <div className="container">
            <div
              className="HContainer"
              style={{ display: "flex", flexDirection: "row" }}
            >
              <Grid
                item
                xs={7}
                sm={7}
                md={7}
                style={{ width: "280px", minHeight: "100px" }}
              />
              {/* Tarjeta Eficacia SGC oculta por solicitud. Mantener comentada para reactivar si el indicador vuelve al mapa de procesos.
              <Grid item xs={7} sm={7} md={7} style={{ width: "280px" }}>
                <div
                  className="eficacia-container"
                  style={{ width: "180px", marginBottom: "10px" }}
                  onMouseEnter={() => openPercentageDetails()}
                  onMouseLeave={() => openPercentageDetails()}
                >
                  <p className="map-title-container">EFICACIA SGC</p>
                  <div
                    style={{
                      backgroundColor: "#FBB07C",
                      color: "#FFFF",
                      height: "25px",
                      width: "90px",
                      textAlign: "center",
                      borderRadius: "20px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      margin: "auto"
                    }}
                  >
                    <p className="percentage-text-mind-map">76%</p>
                  </div>
                  <div className="eficacia-total-percentage">
                    <span className="map-title-container">META:</span>
                    <span
                      style={{
                        color: "#6A6AD8",
                        fontWeight: "600",
                        fontSize: "11px"
                      }}
                    >
                      90%
                    </span>
                  </div>
                </div>
              </Grid>
              {percentageDetails && (
                <div
                  onMouseLeave={() => openPercentageDetails()}
                  className="eficacia-container"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    width: "100px",
                    backgroundColor: "white",
                    marginLeft: "10px"
                  }}
                >
                  <MiniPill
                    color={"#22C55E"}
                    text={"80%"}
                    iconPosition={true}
                  />
                  <MiniPill
                    color={"#FBB07C"}
                    text={"40% - 80%"}
                    iconPosition={true}
                  />
                  <MiniPill
                    color={"#E5515F"}
                    text={"40%"}
                    iconPosition={true}
                  />
                </div>
              )} */}
            </div>

            <div className="partes-interesadas-container">
              <img
                className="arrow-Side-Right"
                src={images.arrowSideRight}
                alt="arrow"
              />
              {/* <PillElement
                color={"#f0cd01"}
                text={"Partes Interesadas"}
                id="lp-2"
                iconSize={"23px"}
                icon={icons.group}
              /> */}
              {/* <div className="arrow-container-c margin-third-arrow">
                <img
                  className="mind-map-downUp-arrow-large"
                  src={images.arrow_up_down_login}
                  alt="arrow"
                />
              </div> */}

              <div>
                <PillElement
                  color={"#6a6ad8"}
                  text={"Satisfacción al Cliente"}
                  iconPosition={true}
                  id="lp-7"
                  icon={icons.handHeart}
                  position={"right"}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <MainLayout>
        <h3 className="map-text">
          Siempre en la mejora continua de los procesos
        </h3>
        <h4 className="map-text-12">
          Los procesos marcados con * no se encuentran documentados en el
          sistema
        </h4>

        <HomePageCards />
      </MainLayout>
      <ToastNotification
        severity="success"
        summary={toastMessage}
        detail=""
        position="top-center"
        showToast={showToast}
        setShowToast={setShowToast}
        flexible={true}
      />
    </>
  );
};

export default Home;
